import { useEffect, useMemo, useRef, useState } from 'react';
import useLocales from 'src/hooks/useLocales';

// @mui
import {
  Box,
  Card,
  Table,
  Button,
  TableBody,
  Container,
  TableContainer,
  Grid,
  Stack,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  TableCell,
  Autocomplete,
  Chip,
  IconButton,
} from '@mui/material';

import { observer } from 'mobx-react-lite';

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';

import useSettings from 'src/hooks/useSettings';

import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import {
  IRentPaymentParams,
  IRentPaymentReport,
} from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';

import { Controller, useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import Loader from 'src/components/loader/Loader';

import { GetMonthName } from 'src/sections/common/GetMonthName';
import { DateConverter } from 'src/sections/common/DateConverter';
import Label from 'src/components/Label';
import ContractInfoReportDetailsToolbar from './ContractInfoReportDetailsToolbar';
import { IContractReportParam } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import ShopReportDetailsToolbar from '../ShopReport/ShopReportDetailsToolbar';
import * as XLSX from 'xlsx';
import { themeMode } from 'src/utils/general';
import { Icon } from '@iconify/react';
// ----------------------------------------------------------------------
export default observer(function ContractInfoReportIndex() {
  const { ContractInfoStore, ChoqorakCommonDropdown } = useStore();
  const { translate } = useLocales();
  const { loadContractReport, ContractReportResult } = ContractInfoStore;
  const {
    loadShopContractTypeDDL,
    ShopContractTypeOption,
    loadCustomerDDL,
    CustomerOption,
    loadShopDDL,
    ShopOption,
    loadStatusDDL,
    StatusOption,
    loadFloorDDL,
    FloorOption,
  } = ChoqorakCommonDropdown;

  const { themeStretch } = useSettings();
  const [isloading, setIsloading] = useState(false);
  const [floor, setFloor] = useState();
  const [shop, setShop] = useState();
  const [status, setStatus] = useState();
  const [contractType, setContractType] = useState();
  const [customer, setCustomer] = useState();

  const defaultValues = useMemo<IContractReportParam>(
    () => ({
      startDate: new Date(),
      endDate: new Date(),
      shopId: undefined,
      customerId: undefined,
      contractTypeId: undefined,
      contractStatusId: undefined,
    }),
    []
  );
  const methods = useForm<IContractReportParam>({
    defaultValues,
  });
  const { watch, control, setValue } = methods;
  const val = watch();

  useEffect(() => {
    loadShopContractTypeDDL();
    loadCustomerDDL();
    loadFloorDDL();

    loadShopDDL(1, true);
    loadStatusDDL(1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Search = async (e: any) => {
    e.preventDefault();
    setIsloading(true);
    loadContractReport({
      // startDate: val.startDate,
      // endDate: val.endDate,
      customerId: customer,
      // contractTypeId: contractType,
      contractStatusId: status,
    })
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
      });
  };

  const exportToExcel = () => {
    const data =
      ContractReportResult?.list?.map((row, index) => ({
        No: index + 1,
        ContractId: row.contractId ?? '-',
        ContractNumber: row.contractNumber || '-',
        CustomerName: row.customerName || '-',
        CustomerPhone: row.customerPhone || '-',
        ShopCode: row.shopCode || '-',
        ContractType: row.contractType || '-',
        RentCarrency: row.rentCarrency || '-',
        AdvanceRecievedByUserName: row.advanceRecievedByUserName || '-',
        ContractStartDate: row.contractStartDate
          ? new Date(row.contractStartDate).toLocaleDateString('fa-IR')
          : '-',
        ContractEndDate: row.contractEndDate
          ? new Date(row.contractEndDate).toLocaleDateString('fa-IR')
          : '-',
        DiscountStartDate: row.discountStartDate
          ? new Date(row.discountStartDate).toLocaleDateString('fa-IR')
          : '-',
        DiscountEndDate: row.discountEndDate
          ? new Date(row.discountEndDate).toLocaleDateString('fa-IR')
          : '-',
        ApprovedByName: row.approvedByName || '-',
        InitialRentAmount: row.initialRentAmount ?? '-',
        FinalRentPerMonth: row.finalRentPerMonth ?? '-',
        TotalContractDurationRentWithoutDiscount:
          row.totalContractDurationRentWithoutDiscount ?? '-',
        TotalContractDurationRent: row.totalContractDurationRent ?? '-',
        TotalContractDurationPaidRent: row.totalContractDurationPaidRent ?? '-',
        AdvancePayment: row.advancePayment ?? '-',
        ContractStatus: row.contractStatus || '-',
        TerminationDescription: row.terminationDescription || '-',
        TerminationDate: row.terminationDate
          ? new Date(row.terminationDate).toLocaleDateString('fa-IR')
          : '-',
        SettlmentDeductionAmount: row.settlmentDeductionAmount ?? '-',
        DeductedAmountFromAdvancePayment: row.deductedAmountFromAdvancePayment ?? '-',
        ManuallyPaidAmount: row.manuallyPaidAmount ?? '-',
        RemainAmount: row.remainAmount ?? '-',
        DeductionDescription: row.deductionDescription || '-',
      })) || [];

    if (data.length === 0) {
      alert('No data available to export.');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Contract Report');

    XLSX.writeFile(workbook, 'Contract_Report.xlsx');
  };

  return (
    <Page title={translate('ContractInfoReport.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('ContractInfoReport.Title')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('ContractInfoReport.Title')}` },
          ]}
          action={<></>}
        />

        <Grid container display="flex" alignItems="center" justifyContent="center">
          <Grid item xs={12} md={12} spacing={2}>
            <Card
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center', // Use justifyContent instead of justifyItems
              }}
            >
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(6, 1fr)' },
                  }}
                >
                  {/* <LocalizDatePicker
                    name="startDate"
                    label={translate('Report.StartDate')}
                    control={control}
                    size={'small'}
                  />

                  <LocalizDatePicker
                    name="endDate"
                    label={translate('Report.EndDate')}
                    control={control}
                    size={'small'}
                  />
                  <Controller
                    name="contractTypeId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        fullWidth
                        freeSolo
                        onChange={(event, newValue) => setContractType(newValue.value)}
                        options={ShopContractTypeOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.value}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate('ContractType.ContractType')}
                            error={!!error}
                            size="small"
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  /> */}
                  <Controller
                    name="customerId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        fullWidth
                        freeSolo
                        onChange={(event, newValue) => setCustomer(newValue.value)}
                        options={CustomerOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.value}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate('Customer.Customer')}
                            error={!!error}
                            size="small"
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />

                  <Controller
                    name="contractStatusId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        fullWidth
                        freeSolo
                        onChange={(event, newValue) => setStatus(newValue.value)}
                        options={StatusOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.value}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate('contractsInfo.Status')}
                            error={!!error}
                            size="small"
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />

                  <Button
                    sx={{ width: '120px' }}
                    variant="contained"
                    onClick={Search}
                    startIcon={<Iconify icon="eva:search-fill" />}
                  >
                    {translate('ShopReport.Filter')}
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Use justifyContent instead of justifyItems
              >
                <IconButton
                  sx={{ color: themeMode() === 'light' ? 'black' : 'white' }}
                  onClick={exportToExcel}
                >
                  <Icon icon="vscode-icons:file-type-excel" width={24} height={24} />
                </IconButton>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Use justifyContent instead of justifyItems
              >
                <ContractInfoReportDetailsToolbar Report={ContractReportResult} />
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
          <>
            {isloading ? (
              <Loader />
            ) : (
              <>
                <Stack sx={{ p: 1 }}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <TableCell> {translate('GeneralFields.No')}</TableCell>
                          <TableCell>{translate('contractsInfo.ContractNumber')}</TableCell>
                          <TableCell>{translate('contractsInfo.CustomerName')}</TableCell>
                          <TableCell>{translate('contractsInfo.ShopCode')}</TableCell>
                          <TableCell>{translate('contractsInfo.FinalRentPerMonth')}</TableCell>
                          <TableCell>
                            {translate('contractsInfo.TotalContractDurationRent')}
                          </TableCell>
                          <TableCell>
                            {translate('contractsInfo.TotalContractDurationPaidRent')}
                          </TableCell>
                          <TableCell>{translate('contractsInfo.StartDate')}</TableCell>
                          <TableCell>{translate('contractsInfo.EndDate')}</TableCell>
                          <TableCell>{translate('contractsInfo.Status')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ContractReportResult?.list?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell align="left">
                              {' '}
                              <Label color="warning"> {row.contractNumber}</Label>
                            </TableCell>
                            <TableCell align="left">{row.customerName}</TableCell>
                            <TableCell align="left">
                              <Label color="success"> {row.shopCode}</Label>
                            </TableCell>
                            <TableCell align="left">{row.finalRentPerMonth}</TableCell>
                            <TableCell align="left">{row.totalContractDurationRent}</TableCell>
                            <TableCell align="left">{row.totalContractDurationPaidRent}</TableCell>
                            <TableCell align="left">
                              {' '}
                              {<DateConverter date={row.contractStartDate} />}
                            </TableCell>
                            <TableCell align="left">
                              {<DateConverter date={row.contractEndDate} />}
                            </TableCell>
                            <TableCell align="left">{row.contractStatus}</TableCell>
                          </TableRow>
                        ))}

                      </TableBody>
                      <TableHead>
                        <TableRow>
                          <TableCell className="font-bold text-lg" colSpan={2}>
                            {translate('contractsInfo.TotalRecord')}
                          </TableCell>
                          <TableCell className="font-bold text-lg" colSpan={8}>{ContractReportResult?.list?.length}</TableCell>
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableContainer>
                </Stack>
              </>
            )}
          </>
        </Grid>
      </Container>
    </Page>
  );
});
